(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.TiktokPrivatePost = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'TikTok private post data',
            channelName: sourceDetails[sources.TIKTOK_INSIGHTS].name,
            postName: sourceDetails[sources.TIKTOK_INSIGHTS].postName,

            storageDimensions: [
                'post_id'
            ],

            availableDimensions: [
                'companyId',
                'companySetId',
                'day',
                'dayOfWeek', 'hourOfDay',
                'postTagId',
                'hashtag',
                'keyword'
            ],

            fields: {
                post_id: {
                    dataType: dataType.STRING
                },
                native_id: {
                    dataType: dataType.STRING
                },
                company_id: {
                    dataType: dataType.STRING
                },
                company_name: {
                    dataType: dataType.STRING
                },
                presence_handle: {
                    dataType: dataType.STRING
                },
                presence_icon_url: {
                    dataType: dataType.STRING
                },
                presence_reach: {
                    dataType: dataType.INTEGER
                },
                published_at: {
                    dataType: dataType.DATE
                },
                captured_at: {
                    dataType: dataType.DATE
                },
                media_type: {
                    dataType: dataType.STRING
                },
                media_url_persisted: {
                    dataType: dataType.STRING
                },
                message: {
                    dataType: dataType.STRING
                },
                post: {
                    dataType: dataType.OBJECT
                },
                post_url: {
                    dataType: dataType.STRING
                },
                media_url: {
                    dataType: dataType.STRING
                },
                source: {
                    dataType: dataType.INTEGER
                },
                reach: {
                    dataType: dataType.INTEGER
                },
                engagement_total: {
                    dataType: dataType.INTEGER
                },
                social_engagement_total: {
                    dataType: dataType.INTEGER
                },
                likes: {
                    dataType: dataType.INTEGER
                },
                comments: {
                    dataType: dataType.INTEGER
                },
                shares: {
                    dataType: dataType.INTEGER
                },
                impressions: {
                    dataType: dataType.INTEGER
                },
                video_views: {
                    dataType: dataType.INTEGER
                },
                video_length: {
                    dataType: dataType.INTEGER
                },
                video_average_time_watched: {
                    dataType: dataType.INTEGER
                },
                video_view_time: {
                    dataType: dataType.INTEGER
                },
                video_full_view_rate: {
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_view: {
                    dataType: dataType.ABSOLUTE_PERCENT
                },
                engagement_rate_by_impression: {
                    dataType: dataType.ABSOLUTE_PERCENT
                },
                engagement_rate_by_presence_reach: {
                    dataType: dataType.ABSOLUTE_PERCENT
                },
                social_engagement_rate_by_impression: {
                    dataType: dataType.ABSOLUTE_PERCENT
                },
                social_engagement_rate_by_presence_reach: {
                    dataType: dataType.ABSOLUTE_PERCENT
                },
                post_tag_ids: {
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod,
                DataSourceFilterGroupIds.source,
                DataSourceFilterGroupIds.publicPost, // TODO: rename publicPost into just post
                DataSourceFilterGroupIds.ordering
            ]
        };
    }
})();
